export default __webpack_public_path__ + "static/media/GuessJobs2_11.3d56a6b3.png";